import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const schema = z.object({
  q: z.string().default(''),
  status: z.string(),
  packs: z.number().array(),
  date: z.string(),
  selectedAdsHistory: z.number().array(),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
